


















import Vue from 'vue';
import * as Util from '@/util.ts';
import * as Enums from '@/enums.ts';

export default Vue.extend({
  props: {
    notificationType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      message: '',
    };
  },
  methods: {
    onSend() {

      if (!this.$data.message) {
        Util.showError(Util.t?.cannotSendEmptyMessage);
        return;
      }

      const notification: MessageNotification = {
        notificationId: Util.generateId(),
        status: Enums.eNotificationStatuses.pending,
        type: this.$props.notificationType,
        message: this.$data.message,
      };

      Util.sendNotificationToEstablishment(notification);
      Util.eventBus.$emit('closeModals');
    },
    onCancel() {
      Util.eventBus.$emit('closeModals');
    },
    focus() {
      (this.$refs.textarea as HTMLElement).focus();
    },
  },
});
